import React, {useState} from 'react'
import { NavbarStyled, NavbarContainer, NavLogo, NavIcon, MobileIcon, NavMenu, NavItem, NavLink, NavItemButton, ButtonLink, NavHashLink } from './Navbar.styled'
import {FaTimes, FaBars } from 'react-icons/fa'
import { Button } from '../../globalStyle'
import { useEffect } from 'react'
import logo from '../../assets/logo16.svg'


const Navbar = () => {
    const [click, setClick] = useState(false)
    const [button, setButton] = useState(true)

    const handleClick = () => {
        setClick(!click)
    }

    const showButton = () => {
        if(window.innerWidth <= 992){
            setButton(false)
        }else{
            setButton(true)
        }
    }

    useEffect(() => {
        showButton()
    }, [])

    window.addEventListener("resize", showButton)


  return (
    <NavbarStyled>
        <NavbarContainer>
            <NavHashLink logo="true" smooth to="/#" >
                <NavIcon src={logo} alt='' />
            </NavHashLink>
            <MobileIcon onClick={handleClick} >{click? <FaTimes/> : <FaBars/> }</MobileIcon>
            <NavMenu  onClick={handleClick} click={click}>
                <NavItem>
                     <NavHashLink smooth to="/#" >Home</NavHashLink>
                </NavItem>
                <NavItem>
                    <NavHashLink smooth to="/#about" >About</NavHashLink>
                </NavItem>
                <NavItem>
                    <NavHashLink smooth to="/#services" >Services</NavHashLink>
                </NavItem>
                <NavItem>
                    <NavLink to="career/job_desc">Career</NavLink>
                </NavItem>
                {/* <NavItem>
                    {button ? (
                    <ButtonLink to="/sign-up" >
                        <Button  >Join Us</Button>
                    </ButtonLink>

                    ) : 
                    (
                        <ButtonLink to="/sign-up" >
                        <Button bigFont primary >Join Us</Button>
                    </ButtonLink>

                    )}
                </NavItem> */}
            </NavMenu>
        </NavbarContainer>
    </NavbarStyled>
  )
}

export default Navbar